<template>
	<div class="container__contentbody">
		<div class="container__contentbody__slot">
			<slot />
		</div>
	</div>
</template>

<script>
export default {}
</script>

<style scoped>
.container__contentbody {
	max-width: 1200px;
	margin: auto;
}

.container__contentbody__slot {
	position: relative;
	top: -3rem;
	z-index: 0;
	padding: 0 2rem;
	height: 100%;
}

@media screen and (min-width: 1200px) {
	.container__contentbody__slot {
		padding: 0;
	}
}
</style>
